module.exports = __webpack_public_path__ + "img/pen.ece6f47f.svg";